<div>
  <div class="grid">
    <div class="col-12">
      <div class="p-fluid">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="formgroup-inline">
              <button pButton
                      *ngIf="statutOuvrage !== '2' && userService.canEdit()"
                      pRipple
                      type="button"
                      icon="pi pi-plus"
                      class="p-button-success mb-2 humensis-green"
                      (click)="insertRow()"></button>
              <div class="field">
                <p-inputNumber mode="decimal"
                              [style]="{'width':'50px'}"
                              class="inputNumber-width"
                              *ngIf="statutOuvrage !== '2' && userService.canEdit()"
                              [showButtons]="false"
                              [min]="0"
                              [(ngModel)]="rowToAddNumber"
                              [max]="500">
                </p-inputNumber>
              </div>
            </div>
          </div>
        </div>

        <div style="overflow:hidden;width:100%;height:auto">
          <div [hidden]="!(pages && pages.length>0)">
            <app-handsontable
              [id]="idTable"
              [dataset]="pages"
              [settings]="settings"
              [columns]="columns"
              [customCellProps]="customCellProps"
              [resetDataset]="resetDataset"
              (onDataChange)="saveChanges($event)"
              (onCreateRow)="createPageAtterrisage($event)"
              (onRemoveRow)="deletePageAtterrissage($event)"
            >
            </app-handsontable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast key="pages_update"></p-toast>

<p-dialog (onHide)="setTextCell()"
          [modal] = "true"
          [(visible)]="display">
  <p-editor [(ngModel)]="text"
            [style]="{'height':'320px', 'width': '500px'}">

    <ng-template pTemplate="header">
        <span class="ql-formats">
            <select class="ql-size">
              <option value="small"></option>
              <!-- Note a missing, thus falsy value, is used to reset to default -->
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
            <button type="button"
                    class="ql-bold"
                    aria-label="Bold"></button>
            <button type="button"
                    class="ql-italic"
                    aria-label="Italic"></button>
            <button type="button"
                    class="ql-underline"
                    aria-label="Underline"></button>
  <button class="ql-script"
          value="sub"></button>
  <button class="ql-script"
          value="super"></button>
        </span>
    </ng-template>

  </p-editor>
</p-dialog>
